/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */
import { Injectable } from '@angular/core';

@Injectable()
export class SessionDataService {
  public static CcStoreKeyPrefix = 'as.cc.';

  public static readonly GeneralAvailability = 'GeneralAvailability';
  public static readonly GeneralAvailabilityBeforeSettingsPage = 'GeneralAvailabilityBeforeSettingsPage';
  public static readonly GeneralAvailabilityBeforeSpecialCallActivities = 'GABeforeSpecialCallActivities';
  public static readonly WasLogout = 'WasLogout';
  public static readonly VideoChatIsManualChanged = 'VideoChatIsManualChanged';
  public static readonly LiveChatIsManualChanged = 'LiveChatIsManualChanged';
  public static readonly SessionId = 'session_id';
  public static readonly LogToConsole = 'LogToConsole';
  public static readonly StoredAdminPage = 'StoredAdminPage';
  public static readonly StoredAgentPage = 'StoredAgentPage';
  public static readonly SupervisorMessagesCount = 'SupervisorMessagesCount';
  public static readonly TakeOverAvailability = 'TakeOverAvailability';

  public static getMessageDraftKey(channelId: string): string {
    return `message_draft_for_channel_id:${channelId}`;
  }

  public save(key: string, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  public get(key: string, defaultValue: any = null): any {
    const result = sessionStorage.getItem(key);
    if (result === null) {
      return defaultValue;
    }
    return JSON.parse(result);
  }

  public getAndRemove(key: string, defaultValue: any = null): any {
    const result = this.get(key, defaultValue);
    this.remove(key);
    return result;
  }

  public remove(key: string): void {
    sessionStorage.removeItem(key);
  }

  public clear(): void {
    sessionStorage.clear();
  }

  private _isValidChannelDraftMessageObject(draft: any): boolean {
    return draft && typeof draft === 'object' && draft.message && draft.message.trim().length > 0;
  }

  public migrateChannelDraftMessage(oldChannelId: string, newChannelId: string): void {
    const oldDraftKey = SessionDataService.getMessageDraftKey(oldChannelId);
    const newDraftKey = SessionDataService.getMessageDraftKey(newChannelId);

    const draft = this.get(oldDraftKey, null);

    if (this._isValidChannelDraftMessageObject(draft)) {
      const newDraftData = {
        message: draft.message,
        currentIntent: draft.currentIntent,
      };

      this.save(newDraftKey, newDraftData);
      this.remove(oldDraftKey);
    }
  }
}
